import { SERVICE_METHODS } from "./AppEnumerations";

export const API_ENDPOINTS = {
  // authentication
  log_in: { url: `account`, method: SERVICE_METHODS.POST },
  forgot_password: { url: `forgot-password`, method: SERVICE_METHODS.POST },
  verify_otp: { url: `verify-admin-otp`, method: SERVICE_METHODS.POST },
  login_session_select: {
    url: `login-session-select`,
    method: SERVICE_METHODS.POST,
  },
  logout: { url: `logout`, method: SERVICE_METHODS.POST },
  resend_otp: { url: `resend-admin-otp`, method: SERVICE_METHODS.POST },
  verify_forgot_otp: { url: `verify-forgot-otp`, method: SERVICE_METHODS.POST },
  reset_password: { url: `reset-password`, method: SERVICE_METHODS.POST },
  change_password: {
    url: `change-password`,
    method: SERVICE_METHODS.POST,
  },
  // exception handling
  error_handling: { url: `err`, method: SERVICE_METHODS.POST },

  sign_file_urls: {
    url: `file/sign-urls`,
    method: SERVICE_METHODS.POST,
  },
  // Upload Image
  upload_image: {
    url: `upload-image`,
    method: SERVICE_METHODS.POST_CONFIG,
  },
  // Upload Video
  upload_video: {
    url: `upload-video`,
    method: SERVICE_METHODS.POST_CONFIG,
  },
  // Upload Document
  upload_document: {
    url: `upload-document`,
    method: SERVICE_METHODS.POST_CONFIG,
  },
  // Refresh Token
  renew_access_token: {
    url: `refresh-token`,
    method: SERVICE_METHODS.GET,
  },

  // Start Region Drop Down
  global_drop_down: {
    url: `ddl`,
    method: SERVICE_METHODS.POST,
  },
  // End region Drop Down

  // system configuration

  get_system_configuration: {
    url: `menu-config`,
    method: SERVICE_METHODS.GET,
  },
  update_system_configuration: {
    url: `system-configurations`,
    method: SERVICE_METHODS.PUT,
  },
  get_system_version: {
    url: `system-configurations`,
    method: SERVICE_METHODS.GET,
  },
  // Start Region Lookup
  get_all_lookup: {
    url: "lookup",
    method: SERVICE_METHODS.GET,
  },
  delete_lookup: {
    url: "lookup",
    method: SERVICE_METHODS.DELETE,
  },

  active_inactive_lookup: {
    url: `lookup`,
    method: SERVICE_METHODS.POST,
  },
  create_lookup: {
    url: `lookup`,
    method: SERVICE_METHODS.POST,
  },
  update_lookup: {
    url: `lookup`,
    method: SERVICE_METHODS.PUT,
  },
  // End region Lookup

  // Start Region Firm
  get_all_firm: {
    url: "firm",
    method: SERVICE_METHODS.GET,
  },
  delete_firm: {
    url: "firm",
    method: SERVICE_METHODS.DELETE,
  },

  active_inactive_firm: {
    url: `firm`,
    method: SERVICE_METHODS.POST,
  },

  // End region Firm

  // Start Region Measurement Field
  get_all_measurement_field: {
    url: "measurement-field",
    method: SERVICE_METHODS.GET,
  },
  delete_measurement_field: {
    url: "measurement-field",
    method: SERVICE_METHODS.DELETE,
  },

  create_measurement_field: {
    url: `measurement-field`,
    method: SERVICE_METHODS.POST,
  },
  update_measurement_field: {
    url: `measurement-field`,
    method: SERVICE_METHODS.PUT,
  },
  // End region Measurement Field

  // Start Region Measurement Type
  get_all_measurement_type: {
    url: "measurement-type",
    method: SERVICE_METHODS.GET,
  },
  delete_measurement_type: {
    url: "measurement-type",
    method: SERVICE_METHODS.DELETE,
  },

  create_measurement_type: {
    url: `measurement-type`,
    method: SERVICE_METHODS.POST,
  },
  update_measurement_type: {
    url: `measurement-type`,
    method: SERVICE_METHODS.PUT,
  },
  active_inactive_measurement_type: {
    url: `measurement-type`,
    method: SERVICE_METHODS.POST,
  },
  measurement_field_ddl: {
    url: `/measurement-field-ddl`,
    method: SERVICE_METHODS.POST,
  },
  // End region Measurement Type

  // Start Region Gallery Directory

  get_all_gallery_directory: {
    url: "gallery-directory",
    method: SERVICE_METHODS.GET,
  },
  create_gallery_directory: {
    url: "gallery-directory",
    method: SERVICE_METHODS.POST,
  },
  update_gallery_directory: {
    url: "gallery-directory",
    method: SERVICE_METHODS.PUT,
  },
  delete_gallery_directory: {
    url: "gallery-directory",
    method: SERVICE_METHODS.DELETE,
  },

  // End Region Gallery Directory

  // Start Region Gallery Directory Item

  get_all_gallery_directory_item: {
    url: "gallery-item",
    method: SERVICE_METHODS.GET,
  },
  create_gallery_directory_item: {
    url: "gallery-item",
    method: SERVICE_METHODS.POST,
  },
  delete_gallery_directory_item: {
    url: "gallery-item",
    method: SERVICE_METHODS.DELETE,
  },

  // End Region Gallery Directory Item

  // Start Region Branch

  get_all_branch: {
    url: "branch",
    method: SERVICE_METHODS.GET,
  },
  // End Region Branch

  // Start Region HSN SAC Code

  get_all_hsn_sac_code: {
    url: "hsn-sac-code",
    method: SERVICE_METHODS.GET,
  },
  create_hsn_sac_code: {
    url: "hsn-sac-code",
    method: SERVICE_METHODS.POST,
  },
  update_hsn_sac_code: {
    url: "hsn-sac-code",
    method: SERVICE_METHODS.PUT,
  },
  active_inactive_hsn_sac_code: {
    url: `hsn-sac-code`,
    method: SERVICE_METHODS.POST,
  },
  delete_hsn_sac_code: {
    url: "hsn-sac-code",
    method: SERVICE_METHODS.DELETE,
  },
  // End Region HSN SAC Code

  //Start Region claim group

  // claim group
  get_all_claim_group: {
    url: "claim-group",
    method: SERVICE_METHODS.GET,
  },
  active_inactive_claim_group: {
    url: `claim-group`,
    method: SERVICE_METHODS.POST,
  },
  delete_claim_group: {
    url: "claim-group",
    method: SERVICE_METHODS.DELETE,
  },
  create_claim_group: {
    url: "claim-group",
    method: SERVICE_METHODS.POST,
  },
  update_claim_group: {
    url: "claim-group",
    method: SERVICE_METHODS.PUT,
  },
  // role
  get_all_roles: {
    url: "role",
    method: SERVICE_METHODS.GET,
  },
  active_inactive_role: {
    url: `role`,
    method: SERVICE_METHODS.POST,
  },
  create_role: {
    url: `role`,
    method: SERVICE_METHODS.POST,
  },
  update_role: {
    url: "role",
    method: SERVICE_METHODS.PUT,
  },
  delete_role: {
    url: "role",
    method: SERVICE_METHODS.DELETE,
  },
  // End Region claim group

  // Start Region Audit Log
  get_all_audit_log: {
    url: "audit-log",
    method: SERVICE_METHODS.GET,
  },
  //End Region Audit Log

  //Start Region Address
  get_all_Address: {
    url: "address",
    method: SERVICE_METHODS.GET,
  },

  update_address_status: {
    url: "address-status",
    method: SERVICE_METHODS.POST,
  },
  //End Region Address

  // start Region Tax Category
  get_all_tax_category: {
    url: "tax-category",
    method: SERVICE_METHODS.GET,
  },
  delete_tax_category: {
    url: "tax-category",
    method: SERVICE_METHODS.DELETE,
  },
  create_tax_category: {
    url: `tax-category`,
    method: SERVICE_METHODS.POST,
  },
  update_tax_category: {
    url: "tax-category",
    method: SERVICE_METHODS.PUT,
  },
  // End Region Tax Category

  // start Region Tax Components

  get_all_tax_components: {
    url: "tax-components",
    method: SERVICE_METHODS.GET,
  },
  delete_tax_component: {
    url: "tax-components",
    method: SERVICE_METHODS.DELETE,
  },
  create_tax_component: {
    url: `tax-components`,
    method: SERVICE_METHODS.POST,
  },
  update_tax_component: {
    url: "tax-components",
    method: SERVICE_METHODS.PUT,
  },
  // End Region Tax Components

  // Start Region Tax Group

  get_all_tax_groups: {
    url: "tax-groups",
    method: SERVICE_METHODS.GET,
  },
  delete_tax_group: {
    url: "tax-groups",
    method: SERVICE_METHODS.DELETE,
  },
  create_tax_group: {
    url: `tax-groups`,
    method: SERVICE_METHODS.POST,
  },
  update_tax_group: {
    url: "tax-groups",
    method: SERVICE_METHODS.PUT,
  },
  get_tax_component_ddl: {
    url: "/tax-components-ddl",
    method: SERVICE_METHODS.GET,
  },
  //End Region Tax Group

  // Start Region Payment Transaction
  get_all_payment_transaction: {
    url: "payment-transaction",
    method: SERVICE_METHODS.GET,
  },
  //End Region Payment Transaction

  // Start firm purchased subscription
  get_all_firm_purchased_subscription: {
    url: "firm-purchased-subscription",
    method: SERVICE_METHODS.GET,
  },
  get_firm_subscription_detail: {
    url: "subscription-assignment-firm",
    method: SERVICE_METHODS.GET,
  },
  get_assignable_subscription_package: {
    url: "subscription-assignment-package",
    method: SERVICE_METHODS.GET,
  },
  assign_subscription: {
    url: "subscription-assignment",
    method: SERVICE_METHODS.POST,
  },
  cancel_subscription: {
    url: "subscription-assignment-cancel",
    method: SERVICE_METHODS.POST,
  },
  //End firm purchased subscription

  // Start subscription package
  get_all_subscription_package: {
    url: "subscription-package",
    method: SERVICE_METHODS.GET,
  },
  // End subscription package

  // Start expenses
  get_all_expenses: {
    url: "expenses",
    method: SERVICE_METHODS.GET,
  },
  create_expenses: {
    url: `expenses`,
    method: SERVICE_METHODS.POST,
  },
  update_expenses: {
    url: "expenses",
    method: SERVICE_METHODS.PUT,
  },
  delete_expenses: {
    url: "expenses",
    method: SERVICE_METHODS.DELETE,
  },
  // End expenses

  //Start help-category
  get_all_help_category: {
    url: "help-category",
    method: SERVICE_METHODS.GET,
  },
  active_inactive_help_category: {
    url: `help-category`,
    method: SERVICE_METHODS.POST,
  },
  delete_help_category: {
    url: `help-category`,
    method: SERVICE_METHODS.DELETE,
  },
  create_help_category: {
    url: `help-category`,
    method: SERVICE_METHODS.POST,
  },
  update_help_category: {
    url: `help-category`,
    method: SERVICE_METHODS.PUT,
  },
  //End help-category

  //start help-topics
  get_all_help_topics: {
    url: `help-topic`,
    method: SERVICE_METHODS.GET,
  },
  active_inactive_help_topics: {
    url: `help-topic`,
    method: SERVICE_METHODS.POST,
  },
  delete_help_topics: {
    url: `help-topic`,
    method: SERVICE_METHODS.DELETE,
  },
  create_help_topic: {
    url: `help-topic`,
    method: SERVICE_METHODS.POST,
  },
  update_help_topic: {
    url: `help-topic`,
    method: SERVICE_METHODS.PUT,
  },
  //End help-topics
};
